import React from "react";
import HomePage from "./Components/HomePage";

const Home = () => {
  return <HomePage />;
};

export default Home;
